import { createFileRoute } from "@tanstack/react-router";

import { PraxaSkillCatalog } from "../components/praxa/PraxaSkillCatalogSurface";

export const Route = createFileRoute("/w/$workspaceId/skills/")({
  component: PraxaSkillsRoute,
});

function PraxaSkillsRoute() {
  const { workspaceId } = Route.useParams();
  return <PraxaSkillCatalog workspaceId={workspaceId} />;
}
